import { useStore } from '../store/useStore';
import { usePreferenceKey } from './PreferenceKeyContext';
function usePreference(key, defaultValue) {
    if (key === void 0) { key = ''; }
    if (defaultValue === void 0) { defaultValue = undefined; }
    var preferenceKey = usePreferenceKey();
    if (!preferenceKey) {
        throw new Error("usePreference cannot be used outside of a Configurable component. Did you forget to wrap your component with <Configurable>? If you don't want to use Configurable, you can use the useStore hook instead.");
    }
    return useStore(preferenceKey && key ? "".concat(preferenceKey, ".").concat(key) : preferenceKey !== null && preferenceKey !== void 0 ? preferenceKey : key, defaultValue);
}
export { usePreference };
//# sourceMappingURL=usePreference.js.map